import EditorFeatureTitle from "../../components/editor/EditorFeatureTitle"
import EditorFeatureSubtitle from "../../components/editor/EditorFeatureSubtitle"

const ParagraphVariation = () => {
	return (
		<div className='bg-white shadow-sm lg:p-9 xl:p-9 2xl:p-10 flex flex-col overflow-hidden'>
			<EditorFeatureTitle title='Paragraph Variation' />
			<EditorFeatureSubtitle>
				Lorem ipsum dolor sit amet, consectetur adipiscing elit
			</EditorFeatureSubtitle>
			<div className='flex-1 scrollbar-y-2 pr-5 -mr-5 lg:mt-7 xl:mt-8 2xl:mt-9'>
				<div className='lg:space-y-4 2xl:space-y-5'>
					<div className='flex lg:py-4 2xl:py-5 lg:px-5 2xl:px-6 rounded-lg border border-db items-center'>
						<div className='text-xl font-bold text-1b'>10-19</div>
						<div className='text-lg text-7d ml-4'>Words</div>
						<div className='ml-auto bg-ffa text-white lg:w-7 2xl:w-9 lg:h-7 2xl:h-9 font-bold text-xl rounded-full grid place-items-center'>4</div>
					</div>
					<div className='flex lg:py-4 2xl:py-5 lg:px-5 2xl:px-6 rounded-lg border border-db items-center'>
						<div className='text-xl font-bold text-1b'>20-39</div>
						<div className='text-lg text-7d ml-4'>Words</div>
						<div className='ml-auto bg-ffa text-white lg:w-7 2xl:w-9 lg:h-7 2xl:h-9 font-bold text-xl rounded-full grid place-items-center'>3</div>
					</div>
					<div className='flex lg:py-4 2xl:py-5 lg:px-5 2xl:px-6 rounded-lg border border-db items-center'>
						<div className='text-xl font-bold text-1b'>40-59</div>
						<div className='text-lg text-7d ml-4'>Words</div>
						<div className='ml-auto bg-ffa text-white lg:w-7 2xl:w-9 lg:h-7 2xl:h-9 font-bold text-xl rounded-full grid place-items-center'>2</div>
					</div>
					<div className='flex lg:py-4 2xl:py-5 lg:px-5 2xl:px-6 rounded-lg border border-db items-center'>
						<div className='text-xl font-bold text-1b'>60-79</div>
						<div className='text-lg text-7d ml-4'>Words</div>
						<div className='ml-auto bg-ffa text-white lg:w-7 2xl:w-9 lg:h-7 2xl:h-9 font-bold text-xl rounded-full grid place-items-center'>7</div>
					</div>
					<div className='flex lg:py-4 2xl:py-5 lg:px-5 2xl:px-6 rounded-lg border border-db items-center'>
						<div className='text-xl font-bold text-1b'>80-99</div>
						<div className='text-lg text-7d ml-4'>Words</div>
						<div className='ml-auto bg-ffa text-white lg:w-7 2xl:w-9 lg:h-7 2xl:h-9 font-bold text-xl rounded-full grid place-items-center'>9</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default ParagraphVariation
